export default function Tick(props) {
    const fill = props.fill ?? '#212121';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 375.1 375.1">
            <path
                d="M345 44L119 270l-89-89-30 31 119 119L375 75z"
                fill={fill}
            />
        </svg>
    );
}
